export const environment = {
  env: 'staging',
  enableProdMode: true,
  baseUrl: 'https://se-commerce.ui.sestage.us',
  apiBaseUrl: 'https://api.stage.ngin-staging.com',
  commerceImageBase: 'https://se-activation-staging.s3.amazonaws.com',
  commerceApiUri: 'https://api.stage.ngin-staging.com/v3/commerce',
  production: false,
  clareApiUrl: 'https://clare-accounting.stage.ngin-staging.com',
  domainEnvironments: [
    {
      domain: 'sestage.us',
      default: true,
      urls: {
        seApi: 'https://se-api.sestage.us',
      },
    },
    {
      domain: 'stage.ngin-staging.com',
      default: false,
      urls: {
        seApi: 'https://api.stage.ngin-staging.com',
      },
    },
  ],
};
